import React from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { CourseSectionType } from '@scale/shared/defaults';

interface SelectOption {
  label: string;
  value: string;
}

interface ISelectCourseSections {
  value: SelectOption[];
  onChange: (course: SelectOption[]) => void;
  courseId: string;
  courseSectionTypes?: CourseSectionType[];
}

const SelectCourseSections: React.FC<ISelectCourseSections> = ({
  onChange,
  value,
  courseId,
  courseSectionTypes,
}) => {
  const fetchCourseSections = async (search: string) => {
    try {
      const query = { search, courseId, courseSectionTypes };
      const results = await apiFetch(null, `corp-api/find/course-sections`, { query });
      const options = results.titles.map((title: string) => {
        return {
          label: title,
          value: title,
        };
      });

      return {
        options,
      };
    } catch (error) {
      return [];
    }
  };

  return (
    <div>
      <Select
        {...{ onChange, value }}
        loadOptions={fetchCourseSections.bind(this)}
        ignoreCase
        multi
        isClearable
        defaultOptions
        placeholder="Course Sections"
      />
    </div>
  );
};

export default SelectCourseSections;
